import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["spaceKey", "contentId", "contentConfiguration", "navigationPolicy"];
import React from 'react';
import { Experience, ExperienceTrackerContext } from '@atlassian/experience-tracker';
import { useExperienceTracker, useSetUpExperience } from '../experience-tracker';
import { Iframe } from '../iframe';
import { Footer, PageLoadValidation, useFooter, useUrl, useContentSize } from '../page-common';
import { PageNotFoundEmptyState } from '../empty-state';
import messages from './messages';
import { useIntl } from 'react-intl-next';
var IframeWrapper = function IframeWrapper(_ref) {
  var _wrapper;
  var children = _ref.children,
    wrapper = _ref.wrapper;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (_wrapper = wrapper === null || wrapper === void 0 ? void 0 : wrapper(children)) !== null && _wrapper !== void 0 ? _wrapper : children);
};
export var Content = function Content(props) {
  var _hasFooterLogo;
  var spaceKey = props.spaceKey,
    contentId = props.contentId,
    contentConfiguration = props.contentConfiguration,
    navigationPolicy = props.navigationPolicy,
    passThroughProps = _objectWithoutProperties(props, _excluded);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var experienceTracker = useExperienceTracker();
  var _contentConfiguration = contentConfiguration.experiences,
    experience = _contentConfiguration.experience,
    ccExperience = _contentConfiguration.ccExperience;
  useSetUpExperience({
    experienceTracker: experienceTracker,
    contentId: contentId,
    spaceKey: spaceKey,
    experience: experience,
    ccExperience: ccExperience
  });
  var _useUrl = useUrl(props),
    embeddedConfluenceUrl = _useUrl.embeddedConfluenceUrl,
    standaloneConfluenceUrl = _useUrl.standaloneConfluenceUrl;
  /**
   * The difference between hasFooter and hasFooterLogo can be found here
   * https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/40212/cbt-2587-docs-changeset-ux-add-embedded#comment-428798112
   *
   * EDIT 7/17: hasFooterLogo property has been renamed internally for clarity as is now aliased as shouldShowFooter when used internally. Externally, the API remains unchanged.
   */
  var shouldShowFooter = (_hasFooterLogo = props.hasFooterLogo) !== null && _hasFooterLogo !== void 0 ? _hasFooterLogo : true;
  var _useFooter = useFooter({
      experienceTracker: experienceTracker,
      hasFooter: contentConfiguration.hasFooter,
      shouldShowFooter: shouldShowFooter,
      parentProduct: props.parentProduct,
      standaloneConfluenceUrl: standaloneConfluenceUrl
    }),
    showFooter = _useFooter.showFooter,
    footerUrl = _useFooter.footerUrl;
  var _useContentSize = useContentSize(),
    height = _useContentSize.height;
  return /*#__PURE__*/React.createElement(ExperienceTrackerContext.Provider, {
    value: experienceTracker
  }, /*#__PURE__*/React.createElement(Experience, {
    name: experience
  }, /*#__PURE__*/React.createElement(PageLoadValidation, props, function (_ref2) {
    var iframeRef = _ref2.iframeRef,
      handleIframeOnLoad = _ref2.handleIframeOnLoad,
      handleContentLoadStarted = _ref2.handleContentLoadStarted,
      navigationPolicy = _ref2.navigationPolicy,
      handleIframeUnload = _ref2.handleIframeUnload,
      redirectedToLogin = _ref2.redirectedToLogin;
    return /*#__PURE__*/React.createElement(IframeWrapper, {
      wrapper: contentConfiguration.getWrapperElement
    }, embeddedConfluenceUrl ? /*#__PURE__*/React.createElement(Iframe, _extends({
      ref: iframeRef
      // https://hello.atlassian.net/wiki/spaces/~142157567/pages/2224394268/Spike+on+CBT-1814
      ,
      src: redirectedToLogin ? '' : embeddedConfluenceUrl,
      onLoad: handleIframeOnLoad,
      onUnload: handleIframeUnload,
      onContentLoadStarted: handleContentLoadStarted
    }, passThroughProps, {
      navigationPolicy: navigationPolicy,
      style: {
        flex: passThroughProps.isHeightSetFromContent ? "1 0 ".concat(height, "px") : '0 1 100%'
      }
    })) : /*#__PURE__*/React.createElement(PageNotFoundEmptyState, null), showFooter && /*#__PURE__*/React.createElement(Footer, {
      url: footerUrl,
      linkTooltip: formatMessage(messages.viewInConfluence),
      label: formatMessage(messages.poweredBy)
    }));
  })));
};